<template>
  <v-bottom-sheet v-model="status" v-on:click:outside="clear_data()">
    <v-card v-if="user">
      <template v-slot:title>
        <div class="d-flex justify-center">
          {{ user.user_name }}
        </div>
      </template>
      <template v-slot:text>
        <div v-if="person_data && person_data.periods" class="d-flex align-center justify-space-between">
          <p class="mr-1 font-weight-bold" style="writing-mode:vertical-rl; rotate: 235deg;">{{ period_start.format('YYYY') }}</p>
          <v-timeline direction="horizontal" v-if="person_data.periods.length > 0">
            <v-timeline-item
                :dot-color="get_dot_color(period)"
                v-for="period in person_data.periods" :key="period">
              <template v-slot:default>
                <p class="font-weight-bold">
                  {{period.period_name}} {{ period.direction_name }}
                </p>
              </template>
              <template v-slot:opposite>
                <p>{{ moment(period.date_start).format('DD.MM.YYYY') }}</p>
                <p>{{ moment(period.date_end).format('DD.MM.YYYY') }}</p>
              </template>
            </v-timeline-item>
          </v-timeline>
          <p class="ml-1 font-weight-bold" style="writing-mode:vertical-rl; rotate: 235deg;">{{ period_end.format('YYYY') }}</p>
        </div>
        <div v-else class="d-flex align-center justify-center flex-column">
          <v-chip color="red" class="mb-2">
            По данному сотруднику мы не нашли никаких данных!
          </v-chip>
          <v-avatar size="100" color="red">
            <v-icon style="font-size: 70px" :icon="['fas', 'face-grin-beam-sweat']" />
          </v-avatar>
        </div>
      </template>
    </v-card>
  </v-bottom-sheet>
</template>

<script>
import { SP_Drawer_status, SP_Drawer_user } from "@/store/planner/SelectedPeriodStore";
import { CurrentPeriod, PeriodSize } from "@/store/planner/CurrentPeriodStore";
import moment from "moment";
import { TokenGUIDStore } from "@/store/global/SessionStore";

export default {
  name: "UserGraphView",
  props: ['tools'],
  data() {
    return {
      person_data: null
    }
  },
  async beforeMount() {
    await this.get_planner_periods()
  },
  mounted() {
    console.log(`Открываю пользователя: ${this.user.user_name}`)
  },
  methods: {
    moment,
    get_dot_color: function (period) {
      if (period.period_guid && period.direction_guid) {
        return this.tools.find(el=>el.guid === period.period_guid).directions.find(el=>el.guid === period.direction_guid).color
      } else if (period.period_guid) {
        return this.tools.find(el=>el.guid === period.period_guid).color
      } else {
        return 'white'
      }
    },
    clear_data: function () {
      console.log(`Закрываю пользователя: ${this.user.user_name}`)
      this.user = null
      this.status = false
    },
    get_planner_periods: async function () {
      let data = JSON.stringify({
        date: this.start_of_year,
        size: this.range
      })
      let url = `${this.$config.SSL}://${this.$config.ONEADDRESS}/${this.$config.BASE}/${this.$config.API_VERSION}/GetPlannerData`
      let properies = {
        method: 'POST',
        withCredentials: true,
        headers: {
          "Authorization": "Bearer " + this.session_token
        },
        body: data
      }
      await fetch(url, properies)
          .then(response => response.text())
          .then(async result => {
            let periods = JSON.parse(result)
            for (let district of periods) {
              district.users = district.users.sort(function (x, y) {
                if (x.user_name < y.user_name) return -1;
                if (x.user_name > y.user_name) return 1;
                return 0;
              })
            }
            let person = null
            for (let district of periods) {
              for (let user of district.users) {
                if (user.user_guid === this.user.user_guid) {
                  person = user
                }
              }
            }
            if (person.periods) {
              person.periods = person.periods.sort((a, b) => {
                if (new Date(a.date_start) < new Date(b.date_start)) return -1;
                if (new Date(a.date_start) > new Date(b.date_start)) return 1;
                if (new Date(a.date_end) < new Date(b.date_end)) return -1;
                if (new Date(a.date_end) > new Date(b.date_end)) return 1;
                return 0;
              })
            }

            this.person_data = person
          }).catch((err) => {
            console.log('Ошибка получения данных...')
            console.warn(err)
          })
    },
  },
  computed: {
    start_of_year() {
      return moment(this.period_start).startOf('year')
    },
    range() {
      let end = parseInt(this.period_end.format('YYYY'))
      let start = parseInt(this.period_start.format('YYYY'))
      return ((end - start) + 1) * 12
    },
    period_end() {
      return moment(this.period_start).add(this.period_size-1, 'month')
    },
    period_start: {
      get() {
        return CurrentPeriod().get()
      },
      set(value) {
        CurrentPeriod().set(value)
      }
    },
    period_size: {
      get() {
        return PeriodSize().get()
      },
      set(value) {
        PeriodSize().set(value)
      }
    },
    status: {
      get() {
        return SP_Drawer_status().get()
      },
      set(value) {
        SP_Drawer_status().set(value)
      }
    },
    user: {
      get() {
        return SP_Drawer_user().get()
      },
      set(value) {
        SP_Drawer_user().set(value)
      }
    },
    session_token() {
      return TokenGUIDStore().get()
    }
  }
}
</script>

<style lang="scss">
.timeline-helper {
  margin-top: -25px;
}
</style>